import { configureStore } from "@reduxjs/toolkit";
import { photofolioReducer } from "./redux/reducers/reducers";
// import { extraReducer } from "./redux/reducers/extraReducers";

export const store = configureStore({

    reducer: {
        photofolioReducer,
        // extraReducer
    }
    
})

export default store;